import type { StorefrontSection } from '@mlm/shared';
import { storefrontIcon } from '../../lib/icons';

type Cfg = Extract<StorefrontSection, { type: 'valuesGrid' }>['config'];

const COLS: Record<NonNullable<Cfg['cols']>, string> = {
  3: 'grid-cols-1 sm:grid-cols-3',
  4: 'grid-cols-2 lg:grid-cols-4',
};

/** Icon-circle card grid on the brand tint band (token-driven). */
export function ValuesGridSection({ section }: { section: StorefrontSection }) {
  const cfg = section.config as Cfg;
  const cols = cfg.cols ?? 4;
  return (
    <section className="bg-accent py-14">
      <div className="mx-auto max-w-[1100px] px-4 text-center">
        <h2 className="font-heading text-[32px] font-extrabold text-foreground">{cfg.heading}</h2>
        {cfg.subheading && <p className="mt-2 text-sm text-muted-foreground">{cfg.subheading}</p>}
        <div className={`mt-9 grid gap-5 ${COLS[cols]}`}>
          {cfg.items.map((it, i) => {
            const Icon = storefrontIcon(it.icon);
            return (
              <div
                key={i}
                className="rounded-2xl bg-card p-6 text-center shadow-card transition-transform hover:-translate-y-1"
              >
                <span className="mx-auto mb-4 flex h-[54px] w-[54px] items-center justify-center rounded-full bg-primary text-primary-foreground">
                  <Icon className="h-6 w-6" />
                </span>
                <div className="text-[16px] font-bold text-foreground">{it.title}</div>
                <p className="mt-1.5 text-[12.5px] leading-relaxed text-muted-foreground">
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
